// import TweenLite from './vendor/TweenLite';
import Preloader from "./preloader"
import Intro from "./intro"
import Question from "./question"
import Results from "./results"
import Overlay from "./overlay"
import { qsArray } from "./utilities/selectors"

let Application = function (params) {
	if (Application.prototype._singletonInstance) {
		return Application.prototype._singletonInstance
	}
	Application.prototype._singletonInstance = this

	this.initialize(params)
}

Application.prototype.initialize = function (params) {
	// console.log('Application initalizing ' + params);

	Application.tweenLength = 0.5
	Application.tweenStagger = "-=0.25"

	/**
	 *
	 */
	let self = this
	this.preloader = new Preloader({})
	this.overlay = new Overlay()
	this.intro = new Intro({})
	this.question1 = new Question({ elementId: "question-1" })
	this.question2 = new Question({ elementId: "question-2" })
	this.question3 = new Question({ elementId: "question-3" })
	this.question4 = new Question({ elementId: "question-4" })
	this.question5 = new Question({ elementId: "question-5" })
	this.question6 = new Question({ elementId: "question-6" })
	this.questions = [this.question1, this.question2, this.question3, this.question4, this.question5, this.question6]
	this.results = new Results({})

	this.progressBarSegments = qsArray("#progress-bar-overlay .progress-bar-segment")

	// Current screen/state info
	// preloader, intro, question, results
	this.currentState = "preloader"
	this.currentQuestion = 0
	this.totalQuestions = 6
	// this.totalQuestions = 1; // for testing results faster

	this.progressIndex = 0

	// Scoring info
	// array of html element ids that have data attributes that are used to calculate final results
	this.answers = []
	this.score_t100 = 0
	this.score_t150 = 0
	this.score_t200 = 0
	this.score_t350 = 0
	this.score_t400 = 0
	this.score_620cb = 0
	this.score_620mb = 0
	this.mpi_t100 = 0
	this.mpi_t150 = 0
	this.mpi_t200 = 0
	this.mpi_t350 = 0
	this.mpi_t400 = 0
	this.mpi_620cb = 0
	this.mpi_620mb = 0

	this.preloaderClosed = function () {
		this.intro.open()
		this.currentState = "intro"
		window.resizeFrame()
	}

	this.introClosed = function () {
		this.scrollToTopOfPage()
		this.currentState = "question"
		this.currentQuestion = 1
		this.question1.open()
		window.resizeFrame()
	}

	this.questionClosed = function (direction) {
		if (direction > 0) {
			// next question or results
			this.currentQuestion++
		} else {
			// previous question or intro
			this.currentQuestion--
		}
		this.scrollToTopOfPage()
		if (this.currentQuestion === 0) {
			this.intro.open()
			window.resizeFrame()
		} else if (this.currentQuestion === this.totalQuestions + 1) {
			//show results
			this.results.open()
			this.currentState = "results"
			window.resizeFrame()
		} else {
			this.questions[this.currentQuestion - 1].open()
		}
	}

	this.storeAnswer = function (answerId) {
		this.answers[this.currentQuestion - 1] = answerId
		//console.log('history is ', this.answers);
		// just to help see progress
		var trash = this.calculateResults()
	}

	this.calculateResults = function () {
		let answerId
		let answerElement
		this.score_t100 = 0
		this.score_t150 = 0
		this.score_t200 = 0
		this.score_t350 = 0
		this.score_t400 = 0
		this.score_620cb = 0
		this.score_620mb = 0
		for (let x = 0; x < this.answers.length; x++) {
			answerElement = document.getElementById(this.answers[x])
			this.score_t100 += parseInt(answerElement.getAttribute("data-t100"), 10)
			this.score_t150 += parseInt(answerElement.getAttribute("data-t150"), 10)
			this.score_t200 += parseInt(answerElement.getAttribute("data-t200"), 10)
			this.score_t350 += parseInt(answerElement.getAttribute("data-t350"), 10)
			this.score_t400 += parseInt(answerElement.getAttribute("data-t400"), 10)
			this.score_620cb += parseInt(answerElement.getAttribute("data-620cb"), 10)
			this.score_620mb += parseInt(answerElement.getAttribute("data-620mb"), 10)
			console.log("")
			console.log("Question " + x + " score totals:")
			console.log(
				"t400: " + this.score_t400 + " (added " + parseInt(answerElement.getAttribute("data-t400"), 10) + ")"
			)
			console.log(
				"t350: " + this.score_t350 + " (added " + parseInt(answerElement.getAttribute("data-t350"), 10) + ")"
			)
			console.log(
				"t200: " + this.score_t200 + " (added " + parseInt(answerElement.getAttribute("data-t200"), 10) + ")"
			)
			console.log(
				"t150: " + this.score_t150 + " (added " + parseInt(answerElement.getAttribute("data-t150"), 10) + ")"
			)
			console.log(
				"t100: " + this.score_t100 + " (added " + parseInt(answerElement.getAttribute("data-t100"), 10) + ")"
			)
			console.log(
				"620cb: " + this.score_620cb + " (added " + parseInt(answerElement.getAttribute("data-620cb"), 10) + ")"
			)
			console.log(
				"620mb: " + this.score_620mb + " (added " + parseInt(answerElement.getAttribute("data-620mb"), 10) + ")"
			)
		}

		let scores = {
			"t100": this.score_t100,
			"t150": this.score_t150,
			"t200": this.score_t200,
			"t350": this.score_t350,
			"t400": this.score_t400,
			"620cb": this.score_620cb,
			"620mb": this.score_620mb
		}
		let sortedScores = Object.keys(scores).sort(function (a, b) {
			return scores[b] - scores[a]
		})
		// console.log("final sorted score results: ", sortedScores);

		// using highest value for every question to figure out a 100% max percent.
		// this.mpi_t100 = Math.round( (this.score_t100 / 49) * 100);
		// this.mpi_t150 = Math.round( (this.score_t150 / 44) * 100);
		// this.mpi_t200 = Math.round( (this.score_t200 / 51) * 100);
		// this.mpi_t350 = Math.round( (this.score_t350 / 49) * 100);
		// this.mpi_t400 = Math.round( (this.score_t400 / 49) * 100);
		// this.mpi_620cb = Math.round( (this.score_620cb / 50) * 100);
		// this.mpi_620mb = Math.round( (this.score_620mb / 53) * 100);
		this.mpi_t100 = Math.round((this.score_t100 / 49) * 100)
		this.mpi_t150 = Math.round((this.score_t150 / 49) * 100)
		this.mpi_t200 = Math.round((this.score_t200 / 49) * 100)
		this.mpi_t350 = Math.round((this.score_t350 / 49) * 100)
		this.mpi_t400 = Math.round((this.score_t400 / 49) * 100)
		this.mpi_620cb = Math.round((this.score_620cb / 49) * 100)
		this.mpi_620mb = Math.round((this.score_620mb / 49) * 100)

		// Math.min(Math.max(parsed, MIN), MAX)
		console.log("this.mpi_t100: " + this.mpi_t100)
		console.log("this.mpi_t150: " + this.mpi_t150)
		console.log("this.mpi_t200: " + this.mpi_t200)
		console.log("this.mpi_t350: " + this.mpi_t350)
		console.log("this.mpi_t400: " + this.mpi_t400)
		console.log("this.mpi_620cb: " + this.mpi_620cb)
		console.log("this.mpi_620mb: " + this.mpi_620mb)

		return sortedScores
	}

	this.getMPI = function (clubId) {
		let mpi = 0
		switch (clubId) {
			case "t100":
				mpi = this.mpi_t100
				break
			case "t150":
				mpi = this.mpi_t150
				break
			case "t200":
				mpi = this.mpi_t200
				break
			case "t350":
				mpi = this.mpi_t350
				break
			case "t400":
				mpi = this.mpi_t400
				break
			case "620cb":
				mpi = this.mpi_620cb
				break
			case "620mb":
				mpi = this.mpi_620mb
				break
		}
		return mpi
	}

	this.reset = function () {
		this.resetProgressBar()
		this.currentQuestion = 0
		this.intro.open()
		this.currentState = "intro"
		window.resizeFrame()
		this.scrollToTopOfPage()
	}

	this.scrollToTopOfPage = function () {
		try {
			window.scrollTo({
				top: 0,
				behavior: "auto"
			})
		} catch (e) {
			console.log("scroll to top error")
		}
		try {
			window.parent.parent.scrollTo({
				top: 0,
				behavior: "auto"
			})
		} catch (e) {
			console.log("scroll to top error")
		}
	}

	this.fillProgressBar = function () {
		let direction = this.currentQuestion >= this.progressIndex ? 1 : -1
		if (direction === 1) {
			this.progressBarSegments[this.currentQuestion - 1].classList.add("is-active")
		} else if (direction === -1) {
			this.progressBarSegments[this.currentQuestion - 1].classList.remove("is-complete")
		}
		this.progressIndex = this.currentQuestion
	}

	this.clearProgressBar = function (direction) {
		if (direction === 1) {
			this.progressBarSegments[this.currentQuestion - 1].classList.add("is-complete")
		} else if (direction === -1) {
			this.progressBarSegments[this.currentQuestion - 1].classList.remove("is-active")
		}
	}

	this.completeProgressBar = function () {
		this.progressBarSegments[this.currentQuestion - 1].classList.add("is-complete")
	}

	this.resetProgressBar = function () {
		this.progressBarSegments.forEach(function (el) {
			el.classList.add("no-animate")
			el.clientHeight
			el.classList.remove("is-complete")
			el.classList.remove("is-active")
			el.clientHeight
			el.classList.remove("no-animate")
		})
		this.progressIndex = 0
	}

	this.getHeight = function () {
		let height = 770
		let width = window.innerWidth

		// Calc height based on window size and currentState:
		// preloader, intro, question, results
		if (width < 800) {
			height = 667
			if (this.currentState === "results") {
				height = 855
			}
		}

		return height
	}
}

export default Application
